import gql from 'graphql-tag';

export const GET_PROPOSAL_DEAL_TYPES_OPTIONS = gql`
  query GetProposalDealTypes {
    proposalDealTypes {
      label
      value
    }
  }
`;
